<template>
  <div class="row">
    <div class="col-md-12">
      <h3 class="title">{{ $t("page") }}</h3>
    </div>
    <div class="col-md-12 card">
      <div class="card-header">
        <div
          class="text-center"
          v-loading="loading"
          :element-loading-text="$t('loading_template') + '...'"
        ></div>
      </div>
      <div class="card-body row">
        <div class="col-md-12">
          <div class="form-group">
            <label>{{$t("page_title")}}</label>
            <input
              class="form-control"
              v-model="pageDetails.pageTitle"
              type="text"
              :placeholder="$t('enter_title')"
            />

            <div class="next-page">
              {{$t("is_it_the_crown_page")}}
              <p-switch
                type="primary"
                v-model="isCrownPage"
                :on-text="$t('yes')"
                :off-text="$t('no')"
              ></p-switch>
            </div>

          </div>
          <div>
            <label for="backgroundImage">{{ $t('background_image') }}</label>
            <input
              id="backgroundImage"
              class="form-control"
              type="file"
              @change="setPageImage($event, 'backgroundImage')"
            />
          </div>
          <div>
            <label for="titleIcon">{{ $t('title_icon')}}</label>
            <input
              id="titleIcon"
              class="form-control"
              type="file"
              @change="setPageImagetitleIcon($event)"
            />
          </div>
          <div style="display: none">
            <label for="leftBottomLogo">{{ $t('bottom_left_image') }}</label>
            <input
              id="leftBottomLogo"
              class="form-control"
              type="file"
              @change="setPageImageleftBottomLogo($event)"
            />
          </div>
          <div>
            <label for="rightBottomLogo">{{ $t('bottom_right_image')}}</label>
            <input
              id="rightBottomLogo"
              class="form-control"
              type="file"
              @change="setPageImagerightBottomLogo($event)"
              placeholder
            />
          </div>
          <div class="mt-2">
            <span>
              {{ $t('is_it_the_parent_page') }}
              <p-switch
                type="primary"
                v-model="pageDetails.isItParent"
                :on-text="$t('yes')"
                :off-text="$t('no')"
              ></p-switch>
            </span>
          </div>

        </div>
      </div>
    </div>
    <div class="col-md-12 card">
      <div class="card-body row">
        <!-- <p-button class="btn btn-primary pull-right" @click="handleCreateModal">
          <i class="fa fa-plus"></i> File Mananger
        </p-button>-->

        <div
          class="col-lg-12 col-md-12"
          v-for="(element, index) in pageTemplate.elements"
          :key="index"
        >
          <p>
            <fg-input v-if="element.field.type === 'categories'">
              <el-select
                size="large"
                class="select-primary"
                multiple
                filterable
                clearable
                v-model="form[element.field.name]"
                :placeholder="$('select_categories')"
              >
                <el-option-group
                  v-for="group in categories"
                  :key="group.id"
                  :label="group.name"
                >
                  <el-option
                    v-for="item in group.children"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-option-group>
              </el-select>
            </fg-input>
          </p>

          <text-field
            :key="'input_text_' + index"
            v-if="element.field.type === 'text'"
            :unique-id="index"
            :label="element.field.title"
            v-model="form[element.field.name]"
          ></text-field>

          <fg-input
            v-if="element.field.type === 'dropdown'"
            :label="element.field.title"
          >
            <el-select
              size="large"
              class="select-primary"
              v-model="form[element.field.name]"
              filterable
              clearable
              :placeholder="element.field.title"
            >
              <el-option
                class="select-primary"
                v-for="item in element.field.choices"
                :key="item.id"
                :label="item.text"
                :value="item.text"
              ></el-option>
            </el-select>
          </fg-input>

          <!-- <rich-html
            v-if="element.field.type === 'editor'"
            v-model="form[element.field.name]"
            :unique-id="index"
          ></rich-html> -->

          <vue-editor
            v-if="element.field.type === 'editor'"
            v-model="form[element.field.name]"
          />
          <div v-if="element.field.type === 'editor'">
            <div class="next-page">
              {{ $t('is_it_the_first_page') }}
              <p-switch
                type="primary"
                v-model="isFirstPage"
                :on-text="$t('yes')"
                :off-text="$t('no')"
              ></p-switch>
            </div>
            <div class="form-group" v-if="!isFirstPage">
              <label :for="'gridPageId_' + index">{{ $t('previous_page') }}</label>
              <el-select
                v-model="inputs[index].prevPageId"
                :placeholder="$t('select_previous_page')"
              >
                <el-option
                  class="select-default select-page-id"
                  v-for="(item, i) in pageOptions"
                  :key="i"
                  :label="item.title"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>

            <div class="next-page">
              {{ $t('is_it_the_last_page') }}
              <p-switch
                type="primary"
                v-model="isLastPage"
                :on-text="$t('yes')"
                :off-text="$t('no')"
              ></p-switch>
            </div>
            <div class="form-group" v-if="!isLastPage">
              <label :for="'gridPageId_' + index">{{ $t('next_page') }}</label>
              <el-select
                v-model="inputs[index].nextPageId"
                :placeholder="$t('select_next_page')"
              >
                <el-option
                  class="select-default select-page-id"
                  v-for="(item, i) in pageOptions"
                  :key="i"
                  :label="item.title"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div v-if="element.field.type === 'file'">
            <label :for="'file_' + index">{{ element.field.title }}</label>
            <input
              :id="'file_' + index"
              :key="'file_key_' + index"
              class="form-control"
              type="file"
              @change="setImage($event, element.field.name)"
              placeholder
            />
          </div>
          <!--          <file-upload-->
          <!--            v-if="element.field.type === 'file'"-->
          <!--            @input="form[element.field.name] = setImage($event)"-->
          <!--            :label="element.field.title"-->
          <!--          ></file-upload>-->
        </div>
        <div class="col-lg-12 col-md-12">
          <div v-for="(grid, index) in grids.elements" :key="index">
            <div
              v-if="grids.type === 'grid'"
              :unique-id="index"
              :key="'grid_container_' + index"
            >
              <fieldset class="border p-2">
                <legend class="w-auto">{{ $t('grid') }} {{ index }}</legend>

                <div class="form-group">
                  <label :for="'gridTitle_' + index">{{ $t('title') }}</label>
                  <input
                    :id="'gridTitle_' + index"
                    :key="'gridTitle_key_' + index"
                    class="form-control"
                    type="text"
                    v-model="inputs[index].title"
                    placeholder
                  />
                </div>

                <!-- <div class="form-group">
                  <label :for="'gridURL_' + index">URL</label>
                  <input
                    :id="'gridURL_' + index"
                    :key="'gridURL_key_' + index"
                    class="form-control"
                    type="url"
                    v-model="inputs[index].url"
                    placeholder
                  />
                </div> -->
                <div class="form-group">
                  <label :for="'gridPageId_' + index">{{ $t('page') }}</label>
                  <el-select
                    v-model="inputs[index].pageId"
                    :placeholder="$t('select_page')"
                  >
                    <el-option
                      class="select-default select-page-id"
                      v-for="(item, i) in pageOptions"
                      :key="i"
                      :label="item.title"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <!-- <input
                    :id="'gridPageId_' + index"
                    :key="'gridPageId_key_' + index"
                    class="form-control"
                    type="tel"
                    v-model="inputs[index].pageId"
                    placeholder
                  /> -->
                </div>

                <div class="form-group">
                  <label :for="'gridSNumber_' + index">{{ $t('sort_number') }}</label>
                  <input
                    :id="'gridSortNumber_' + index"
                    :key="'gridSortNumber_key_' + index"
                    class="form-control"
                    type="text"
                    v-model="inputs[index].sortNumber"
                    placeholder
                  />
                </div>

                <label :for="'gridFile_' + index">{{ $t('image_icon') }}</label>
                <input
                  type="file"
                  @change="setGridImage($event, index)"
                  :id="'gridFile_' + index"
                  :key="'gridFile_key_' + index"
                  class="form-control"
                />
              </fieldset>

              <button
                @click="addGrid(index)"
                :key="'grid_add_btn_' + index"
                :id="'grid_add_btn_' + index"
                class="btn btn-info pull-right"
                v-show="index == grids.elements.length - 1"
              >
                +
              </button>
              <button
                @click="removeGrid(index)"
                :key="'grid_remove_btn_' + index"
                :id="'grid_remove_btn_' + index"
                class="btn btn-danger pull-right"
                v-show="index || (!index && grids.elements.length > 1)"
              >
                X
              </button>
            </div>
          </div>
          <button class="btn btn-info btn-block" @click="savePagePost()" v-loading="saving"
           element-loading-text="Saving data...">
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Option, Select, Table, TableColumn } from "element-ui";
import PPagination from "src/components/UIComponents/Pagination.vue";
import PSwitch from "src/components/UIComponents/Switch.vue";
import Modal from "src/components/UIComponents/Modal.vue";
import TextField from "@/components/UIComponents/TOL/TitleField.vue";
// import RichHtml from "@/components/UIComponents/TOL/RichHtml.vue";
import { VueEditor } from "vue2-editor";

// import TextareaField from "@/components/UIComponents/TOL/Textarea.vue";
import FileUpload from "@/components/UIComponents/TOL/FileUpload.vue";
// import SelectBox from "@/components/UIComponents/TOL/SelectBox.vue";
import Grid from "@/components/UIComponents/TOL/Grid.vue";

import Resource from "@/util/Api/resource.js";
import { fetchPageTemplate } from "@/util/Api/pageTemplate.js";
import { savePage } from "@/util/Api/page.js";
import { fetchPages } from "@/util/Api/page.js";

Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);

const CategoryResource = new Resource("category");
const UserResource = new Resource("user");
const FileResource = new Resource("files");

export default {
  name: "PageComponent",
  components: {
    TextField,
    // RichHtml,
    VueEditor,
    // TextareaField,
    FileUpload,
    // SelectBox,
    Grid,
    PPagination,
    Modal,
    PSwitch,
  },

  computed: {
    pagedData() {
      return this.tableData.slice(this.from, this.to);
    },
    queriedData() {
      if (!this.searchQuery) {
        this.pagination.total = this.tableData.length;
        return this.pagedData;
      }
      let result = this.tableData.filter((row) => {
        let isIncluded = false;
        for (let key of this.propsToSearch) {
          let rowValue = row[key].toString();
          rowValue = rowValue.toLowerCase();
          this.searchQuery = this.searchQuery.toLowerCase();
          if (rowValue.includes && rowValue.includes(this.searchQuery)) {
            isIncluded = true;
          }
        }
        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      this.pagination.total = this.tableData.length;
      return this.tableData.length;
    },
  },

  data() {
    return {
      backgroundImage: "",
      rightBottomLogo: "",
      leftBottomLogo: "",
      modals: {
        classic: false,
      },
      loading: false,
      saving: false,
      propsToSearch: ["file_name"],
      contentTypeObject: [
        {
          label: "Content Page Editor",
          value: 28,
        },
        {
          label: "grid page",
          value: 17,
        },
      ],


      tableData: [],
      files: [],

      pageTemplate: [],
      PageContent: {
        categories: [],
      },
      pageTitles: [],
      pageOptions: [],
      grids: [],
      form: [],
      categories: [],
      users: [],
      counter: 0,
      pageDetails: {
        pageTitle: "",
        isItParent: false,
        backgroundImage: "",
        titleIcon: "",
        leftBottomLogo: "",
        rightBottomLogo: "",
      },
      isLastPage: true,
      isFirstPage: true,
      pageTitle: "",
      isItParent: false,
      inputs: [
        {
          title: "",
          url: "",
          pageId: null,
          nextPageId: null,
          prevPageId: null,
          file: null,
          sortNumber: null,
        },
      ],
      base64: null,
      mainPostTitle: "",
      isCrownPage: false
    };
  },

  created() {
    this.getPageTemplate();
    this.getCategories();
    this.getUsers();
    this.getPages();
  },

  methods: {

    setPageImageleftBottomLogo($event) {
      let file = $event.target.files[0];
      this.leftBottomLogo = file;
    },

    setPageImagetitleIcon($event) {
      let file = $event.target.files[0];
      this.titleIcon = file;
    },

    setPageImagerightBottomLogo($event) {
      let file = $event.target.files[0];
      this.rightBottomLogo = file;
    },

    async setPageImage($event, fieldName) {
      let file = $event.target.files[0];
      if (
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg"
      ) {
        if (file.size < 2097152) {
          this.pageDetails[fieldName] = file;
        } else {
          this.showAlertMessage(
            this.$t("image_size_too_large_image_size_cannot_be_more_than_2mb"),
            "error"
          );
        }
      } else {
        this.pageDetails[fieldName] = "";
        this.showAlertMessage(
          this.$t("file_format_not_supported_supported_file_types_are_jpg_jpeg_png"),
          "error"
        );
      }
    },

    async setImage($event, fieldName) {
      let file = $event.target.files[0];
      if (
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg"
      ) {
        if (file.size < 2097152) {
          this.form[fieldName] = file;
        } else {
          this.showAlertMessage(
            this.$t("image_size_too_large_image_size_cannot_be_more_than_2mb"),
            "error"
          );
        }
      } else {
        this.form[fieldName] = "";
        this.showAlertMessage(
          this.$t("file_format_not_supported_supported_file_types_are_jpg_jpeg_png"),
          "error"
        );
      }
    },

    async setGridImage($event, index) {
      let file = $event.target.files[0];

      if (
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg"
      ) {
        if (file.size < 2097152) {
          this.inputs[index].file = await this.convertImage(file).catch((e) =>
            Error(e)
          );
          this.rightBottomLogo = file;
        } else {
          this.showAlertMessage(
            this.$t("image_size_too_large_image_size_cannot_be_more_than_2mb"),
            "error"
          );
        }
      } else {
        this.showAlertMessage(
          this.$t("file_format_not_supported_supported_file_types_are_jpg_jpeg_png"),
          "error"
        );
      }
    },

    convertImage(file) {
      // let file = $event.target.files[0];
      return new Promise(function (resolve, reject) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          return resolve(reader.result);
        };
        reader.onerror = function (error) {
          return reject(error);
        };
      });
    },

    onCopy() {
      this.showAlertMessage(this.$t("url_copied_to_clipboard"), "success");
      this.modals.classic = false;
    },

    onCopyError() {
      this.showAlertMessage(this.$t("failed_to_copy_url"), "error");
    },

    async getFiles() {
      this.loading = true;
      await FileResource.list({})
        .then((response) => {
          this.loading = false;
          this.tableData = response.data;
          this.files = response.data;
        })
        .catch((error) => {
          this.loading = false;
          // this.showAlertMessage(error.message, "success");
        });
    },

    handleCreateModal() {
      this.modals.classic = true;
    },

    async getPages() {
      this.loading = true;
      await fetchPages({})
        .then((response) => {
          let page = {};
          response.data.forEach((post) => {
            this.pageTitles.push(post.post.title);
            this.pageOptions.push({
              title: post.post.title.split('___')[0],
              id: post.post.id,
            });
          });
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    // get page template
    async getPageTemplate() {
      await fetchPageTemplate(this.$route.params.id)
        .then((response) => {
          this.pageTemplate = response.data;
          this.pageTemplate.elements.forEach((element) => {
            if (element.field.type === "grid") {
              this.grids = {
                type: "grid",
                elements: ["grid_0"],
              };
              return true;
            }
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    // add grid
    addGrid(index) {
      this.counter++;
      this.inputs.push({ title: "", url: "" });
      this.grids.elements.push("grid_" + this.counter);
    },

    // remove the grid
    removeGrid(index) {
      this.inputs.splice(index, 1);
      this.grids.elements.splice(index, 1);
    },

    // the grid function
    setGrid(value, gridObject, valueKey) {
      const gridKey = gridObject.name; // grid_1 or grid_2
      const gridValueKey = valueKey; // value_1 or value_2

      if (this.form[gridKey])
        this.form[gridKey] = Object.assign(this.form[gridKey], {
          [gridValueKey]: value,
        });
      else {
        this.form[gridKey] = { [gridValueKey]: value };
      }
    },

    // saving page
    async savePagePost() {
      this.saving = true;
      let obj = [];
      let counterIndex = 0;
      let nextPageId = null;
      let prevPageId = null;

      this.inputs.forEach((input) => {
        if (input.nextPageId && this.isLastPage === false) {
          nextPageId = input.nextPageId;
        }
        if (input.prevPageId && this.isFirstPage === false) {
          prevPageId = input.prevPageId;
        }
        input.title = input.title ? input.title : "";
        input.url = input.url ? input.url : "";
        input.pageId = input.pageId ? input.pageId : "";
        input.file = input.file ? input.file : "";
        input.sortNumber = input.sortNumber ? input.sortNumber : "";
      });

      this.pageTemplate.elements.forEach((element) => {
        if (this.form[element.field.name] === undefined) {
          this.form[element.field.name] = "";
        }

        obj[counterIndex] = {
          id: element.id,
          fieldNumber: element.fieldNumber,
          type: element.field.type,
          name: element.field.name,
          answer:
            element.field.type === "grid"
              ? this.inputs
              : this.form[element.field.name],
        };

        counterIndex++;
      });

      if(!this.isFirstPage && prevPageId !== null) {
        this.pageDetails.pageTitle = this.pageDetails.pageTitle + "___" + "prevPage-"+prevPageId;
      }
      if(!this.isLastPage && nextPageId !== null) {
        this.pageDetails.pageTitle = this.pageDetails.pageTitle + "___" + "nextPage-" + nextPageId;
      }

      if ( this.isCrownPage ) {
         this.pageDetails.pageTitle = "isCrown--" +this.pageDetails.pageTitle;
       }

      let formData = new FormData();
      formData.append("title", this.pageDetails.pageTitle);
      formData.append("postTemplateID", this.$route.params.id);
      formData.append("backgroundImage", this.pageDetails.backgroundImage);

      if(this.$route.params.formDetails.ngo_ID !== undefined) {
         formData.append("ngo_ID", this.$route.params.formDetails.ngo_ID);
      }

      if(this.$route.params.formDetails.location_ID !== undefined) {
         formData.append("location_ID", this.$route.params.formDetails.location_ID);
      }

      if(this.$route.params.formDetails.language_ID !== undefined) {
         formData.append("language_ID", this.$route.params.formDetails.language_ID);
      }

      if(this.$route.params.formDetails.categories !== undefined) {
          let allCategory = this.$route.params.formDetails.categories;
          await allCategory.forEach(catID => {
            formData.append("categories[]", catID);
          });
      }

      if (this.titleIcon !== undefined) {
         formData.append("titleIcon", this.titleIcon);
      }
      if (this.leftBottomLogo !== undefined) {
         formData.append("leftBottomLogo", this.leftBottomLogo);
      }

      if (this.rightBottomLogo !== undefined) {
         formData.append("rightBottomLogo", this.rightBottomLogo);
      }

      formData.append("isItParent", await this.pageDetails.isItParent);
      formData.append("answers", JSON.stringify(obj));

      // formData.forEach((value, key) => {
      //    console.log("key %s: value %s", key, value);
      // });

      //return;

      await savePage(formData)
        .then((response) => {
          //console.log(response);
          this.loading = false;
          this.showAlertMessage(this.$t("post_created_successfully"), "success");
          this.$router.push({ name: "Pages" });
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
          // if (error.response.data.error) {
          //   this.$refs.formBuilderForm.setErrors(error.response.data.error.message);
          // }
        });
    },

    // get all users
    async getUsers() {
      await UserResource.list({})
        .then((response) => {
          this.users = response.data;
        })
        .catch((error) => {
          console.log("error occured");
        });
    },

    // get all categories
    async getCategories() {
      await CategoryResource.list({})
        .then((response) => {
          this.categories = response.data;
        })
        .catch((error) => {
          console.log("error occured");
        });
    },

    setData(index) {},

    showAlertMessage(message, type) {
      this.$message.closeAll();
      this.$message({
        type: type,
        message: message,
      });
    },
  },
};
</script>
<style scoped>
.grid__unit {
  margin-bottom: 20px;
}
.el-select.select-primary.el-select--large {
  margin-top: 30px;
}
.next-page {
  padding-top: 20px;
  padding-bottom: 10px;
  font-size: 0.8571em;
  color: #9a9a9a;
}
</style>
